import React from 'react';
import { MARGEN } from '../../lib/exceso';

const DIAS_CORTOS = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

/** CUÁNTO DEL DÍA ESTÁ CREADO (15-10): la media de proteína, hidratos y grasa creadas frente
 *  a su objetivo, cada una contada como mucho al 100 %. Antes era el % de comidas TERMINADAS,
 *  y un día con alimentos pero corto salía «—», igual que uno vacío (el sábado de una comida
 *  única sin cuadrar). Sin nada creado, `null`, que la casilla pinta «—». */
export const pctDelDia = (macros, objetivo) => {
    if (!objetivo || !macros) return null;
    const ks = ['P', 'H', 'G'].filter((k) => (objetivo[k] || 0) > 0);
    if (!ks.length || !ks.some((k) => (macros[k] || 0) > 0)) return null;
    const suma = ks.reduce((acc, k) => acc + Math.min(1, (macros[k] || 0) / objetivo[k]), 0);
    return Math.round((suma / ks.length) * 100);
};

/** LA CASILLA DE LA MAQUETA DEL 14-10: el día elegido en naranja entero; hoy, con su
 *  nombre y su punto en naranja; y lo terminado, el porcentaje a secas, sin colores. */
// EL COLOR DE CADA DÍA (handoff «Mi semana», 16-10), con la regla de color de siempre (Enrique:
// «mantén la actual»): verde el día montado y cuadrado, naranja si algún macro del día pasa del
// objetivo por más del margen (los 4 g de `lib/exceso`), blanco el que va a medias y sin relleno
// el vacío. Se juzga con los totales del día que ya trae la semana: el estado de cada comida
// pediría el reparto de los siete días.
export const colorDelDia = (dia) => {
    const { macros, objetivo } = dia || {};
    if (!dia || dia.estado === 'sin_montar' || !macros) return null;
    if (objetivo && ['P', 'H', 'G'].some((k) => (macros[k] || 0) - (objetivo[k] || 0) > MARGEN)) return 'pasa';
    if (dia.estado === 'montada' && dia.is_cuadrado) return 'cuadrado';
    return 'medias';
};
const RELLENO = { cuadrado: 'bg-ok', pasa: 'bg-pasado', medias: 'bg-foreground' };

const Casilla = ({ dia, indice, esHoy, activo, pct, onClick }) => {
    const sinNada = pct == null || pct === 0;
    const pie = pct === undefined ? '…' : !sinNada ? `${pct} %` : '—';
    const color = colorDelDia(dia);
    // En la elegida (fondo claro), el «a medias» blanco no se vería: va en oscuro.
    const relleno = color === 'medias' && activo ? 'bg-background' : RELLENO[color];
    return (
        // LA CASILLA DEL HANDOFF (16-10): el día (o «Hoy», en naranja), el número, una barrita con
        // lo creado en el color del día y el porcentaje. La elegida va en claro: el naranja se
        // queda para las acciones.
        <button type="button" onClick={onClick} data-testid={`semana-dia-${dia.fecha}`} aria-pressed={activo}
            aria-label={`${DIAS_CORTOS[indice]} ${Number(String(dia.fecha).slice(8, 10))}${esHoy ? ', hoy' : ''}${sinNada ? ', vacío' : `, ${pct} % creado`}`}
            className={`min-w-0 rounded-xl border pt-[9px] pb-2 flex flex-col items-center gap-1 transition-colors
                ${activo ? 'border-foreground bg-foreground text-background' : 'border-border bg-card text-foreground hover:border-foreground/25'}`}>
            <span className={`text-[11px] font-bold ${
                esHoy ? (activo ? 'text-brand-dark' : 'text-brand') : activo ? 'text-background' : 'text-muted-foreground'}`}>
                {esHoy ? 'Hoy' : DIAS_CORTOS[indice]}
            </span>
            <span className="font-heading text-[21px] font-bold leading-none">
                {Number(String(dia.fecha).slice(8, 10))}
            </span>
            <span className={`w-[70%] h-[3px] rounded-full overflow-hidden ${activo ? 'bg-black/15' : 'bg-muted'}`}>
                {relleno && !sinNada && (
                    <span className={`block h-full rounded-full ${relleno}`} style={{ width: `${Math.min(100, pct || 0)}%` }} />
                )}
            </span>
            <span className={`text-[10.5px] font-semibold font-data ${
                activo ? 'text-background' : sinNada ? 'text-muted-foreground/60' : 'text-foreground/80'}`}>
                {pie}
            </span>
        </button>
    );
};

const DiaDeLaFranja = ({ dia, ...resto }) => (
    <Casilla dia={dia} pct={pctDelDia(dia.macros, dia.objetivo)} {...resto} />
);

export default DiaDeLaFranja;
